import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import isString from "@frog/source/utility/isString.js"
import convertOldOverworldScripting from "./convertOldOverworldScripting.js"

import unitJobs from "./unit-jobs"
import player from "./player.js"

export default function convertOldChapterScripting(oldconditions, afterVictoryEvents, victory) {
    oldconditions["0:start"] = oldconditions["0:start"] || []
    const conditions = Object.keys(oldconditions).map((conditionKey) => {
        const condition = {
            "type": "turn:" + conditionKey,
            "events": []
        }

        if(condition.type == "turn:0:start") {
            condition.events.push(PlotSteps.SpawnPlayerPartyScript({
                "isIgnoringEncounterBounds": true,
                "spotTag": "spawngood"
            }))
            condition.events.push(PlotSteps.PlayAudio("PirateMusic:Combat:3"))
        }

        const oldevents = oldconditions[conditionKey]
        oldevents.forEach((oldevent) => {
            if(oldevent.type == "SpawnUnit") {
                const unit = {
                    "key": oldevent.spawn.key,
                    "jobKey": oldevent.spawn.classKey,
                    "affiliation": oldevent.spawn.affiliation,
                    "position": oldevent.spawn.position,
                    "health": oldevent.spawn.health,
                    "maxhealth": oldevent.spawn.maxhealth,
                }
                if(unit.jobKey != undefined) {
                // && unitJobs[unit.jobKey] != undefined) {
                    // unit.protounit = unitJobs[unit.jobKey]
                    unit.jobKey = "hero/" + unit.jobKey
                }
                if(unit.key != undefined
                && player.party.units[unit.key] != undefined) {
                    unit.protounit = player.party.units[unit.key]
                }
                condition.events.push(PlotSteps.SpawnUnit(unit))
            } else if(oldevent.type == "MoveUnit") {
                oldevent.position.z = oldevent.position.z ?? 1
                condition.events.push(PlotSteps.MoveUnit({
                    "unitKey": oldevent.classKey,
                    "position": oldevent.position,
                }))
            } else if(oldevent.type == "DisplayDialogue") {
                condition.events.push(PlotSteps.Dialogue({
                    "unitKey": oldevent.classKey,
                    "text": oldevent.dialogue.text,
                    "data": {
                        "speakerKey": oldevent.dialogue.name.toLowerCase(),
                        "scene": {
                            "units": [
                                {
                                    "key": oldevent.dialogue.name.toLowerCase(),
                                    "position": oldevent.dialogue.side == "right" ? 4 : 1,
                                    "direction": oldevent.dialogue.side == "right" ? "left" : "right",
                                    "expression": oldevent.dialogue.expression,
                                }
                            ]
                        }
                    },
                }))
            } else if(oldevent.type == "StopDialogue") {
                condition.events.push(PlotSteps.CloseDialogue())
            } else if(oldevent.type == "Wait") {
                condition.events.push(PlotSteps.Wait(oldevent.time * 1000))
            } else if(oldevent.type == "TransitionScreen") {
                condition.events.push({"func": () => Navigation.go(oldevent.url)})
            } else if(oldevent.type == "PlayStinger") {
                condition.events.push({"func": () => Audiomix.trigger(oldevent.sound.name)})
            }
        })

        return condition
    })
    conditions.push({
        "type": "condition",
        "condition": (stage) => {
            return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
        },
        "events": [
            PlotSteps.ChapterFailure(),
            {"func": () => App.game.chapter.restart()},
        ]
    })


    if(afterVictoryEvents instanceof Array) {
        afterVictoryEvents = convertOldOverworldScripting(afterVictoryEvents)
    } else if(isString(afterVictoryEvents)) {
        afterVictoryEvents = [
            {"func": () => Navigation.go(afterVictoryEvents || "/games/hero")},
        ]
    } else {
        afterVictoryEvents = [] // {"func": () => Navigation.go("/games/hero")},
    }

    conditions.push({
        "type": "condition",
        "isWinCondition": true,
        "condition": (stage) => {
            if(victory != undefined
            && victory.turns != undefined
            && stage.turn.number < victory.turns) {
                return false
            }
            return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good"})
        },
        "events": [
            PlotSteps.ChapterSuccess(),
            PlotSteps.UpdatePlayerPartyScript({"permadeath": false}),
            ...afterVictoryEvents
        ]
    })

    return conditions
}
